import {_} from 'lodash';
import {createErrorString} from "../../../util/misc";
import {global} from "../../../appContext";
import PromiseRequest from "../../../req/PromiseRequest";
import {SPINNER} from "../../../constants";
import pubsub from "../../../pubsub";
import {AbstractMulti} from "./AbstractMulti";
import abstract_multi_activateHtml from './abstract-multi-activate.html?raw';

export const template = abstract_multi_activateHtml

export abstract class AbstractMultiActivate extends AbstractMulti {
    protected abstract active: boolean;

    protected getPromiseArray(): (() => Promise<any>)[] {
        return this.selectedObjects.map(messageFlow => () => {
            this.messageData({message: `((updating)) [${messageFlow.name}]... ${SPINNER}`})
            const data = _.defaultsDeep({
                active: this.active,
                messagelog: null,
            }, _.cloneDeep(messageFlow))
            data.body = encodeURIComponent(data.body)
            const jmessage = JSON.stringify(data)
            const req = new PromiseRequest('updatemessage')
            this.requests.push(req)
            return req
                .request({jmessage: jmessage})
                .then(() => this.arrSuccess.push(messageFlow))
                .catch((reason: string) => this.arrError.push({
                    item: messageFlow,
                    error: createErrorString(reason, '_blank')
                }))
        })
    }

    protected onPromiseArraySuccess(): void {
        global.cacheManager.removeCache('searchmessage')
        pubsub.trigger('search.needs.refresh')
        this.messageData(null)
        this.step(this.Step.Success)
    }

}
